import { useState } from 'react'
import { Card, CardHeader, CardBody, Button, Label, Input, FormFeedback, Alert, Spinner } from 'reactstrap'
import useForm from '../CustomHooks/FormHook'
import { CREATE_SCHEMA_MUTATION } from '../../graphql'
import { handleGraphQLErrors } from '../../utils.js'
import { gql } from '@apollo/client'
import { FaArrowLeft } from 'react-icons/fa'

const CREATE_SCHEMA = gql(CREATE_SCHEMA_MUTATION)

export default function CreateSchema() {
  console.log('CreateSchema rendered')

  const { inputs, handleInputChange, resetInputs } = useForm({ schemaName: '' }, handleSubmit)
  const [schemaNameState, setSchemaNameState] = useState({ state: '', message: '' })
  const [spinner, setSpinner] = useState(false)
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [schemaCreated, setSchemaCreated] = useState(false)

  function startOver() {
    resetInputs({ schemaName: '' })
    setSchemaCreated(false)
  }

  async function handleSubmit() {
    console.log('CreateSchema.handleSubmit: ', inputs.schemaName)
    if (!inputs.schemaName) {
      setGraphQLErrors([])
      setSchemaNameState({ state: 'has-danger', message: 'Schema Name is required.' })
    } else {
      setSchemaNameState({ state: '', message: '' })
      setSpinner(true)
      try {
        const { data, errors } = await window.apolloClient.mutate({ mutation: CREATE_SCHEMA, variables: { schemaName: inputs.schemaName.toLowerCase() } })
        if (data.createSchema === 'SUCCESS!') {
          setGraphQLErrors([])
          setSchemaCreated(true)
        } 
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setSpinner(false)
      }
    }
  }

  let button =  <Button color="primary" id="new-schema-button" data-cy="new-schema-button" onClick={handleSubmit}>Create Schema</Button>
  if (spinner) {
    button = <Button disabled color="primary"><Spinner size="sm" /> Creating schema...</Button>
  }

  let cardBody = 
    <CardBody>
      <Alert color="danger" isOpen={graphQLErrors.length ? true : false}>{graphQLErrors.length ? graphQLErrors[0].message : ''}</Alert>
      <Label for="schemaName">Schema Name</Label>
      <Input
        id="schemaName"
        name="schemaName"
        invalid={schemaNameState.state === 'has-danger'}
        valid={schemaNameState.state === 'has-success'}
        onChange={handleInputChange}
        data-cy="schema-name"
      />
      <FormFeedback>{schemaNameState.message}</FormFeedback>
      <div style={{ paddingTop: '10px', textAlign: 'center' }}>
        {button}
      </div>
    </CardBody>

  if (schemaCreated) {
    cardBody = 
      <CardBody>
        <Alert color="success">{`Schema ${inputs.schemaName.toUpperCase()} was created successfully!`}</Alert>
        <div style={{ textAlign: 'center' }}>
          <Button style={{ float: 'left' }} onClick={startOver}><FaArrowLeft /> Start Over</Button>
          <Button color="success" tag="a" target="_blank" href={`${window.location.origin}/${inputs.schemaName.toLowerCase()}/login`}>{`Log into schema ${inputs.schemaName.toUpperCase()}`}</Button>
        </div>
      </CardBody>
  }

  return (
    <Card style={{ maxWidth: '500px', marginTop: '20px' }}>
      <CardHeader style={{ fontWeight: 'bold' }}>Create Schema</CardHeader>
      {cardBody}
    </Card>
  )
}
